export default __webpack_public_path__ + "static/media/image.a5f86e38.png";